<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro de telas</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="CadastroTela.cdtId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-text-field v-model="CadastroTela.cdtNome" :rules="nameRules" :counter="200"
                                        label="Nome Tela" variant="underlined" required></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field v-model="CadastroTela.cdtOrdem" label="Ordem" type="number"
                                        variant="underlined"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="CadastroTela.cdtVisivel" label="Visível" :items="Status"
                                        item-title="nome" item-value="cdtVisivel" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="CadastroTela.cdtUrl" label="Url"
                                        variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" v-if="GrupoTelas!=''">
                                    <v-select v-model="CadastroTela.grtId" label="Grupo Telas" :items="GrupoTelas"
                                        item-title="grtNome" item-value="grtId" variant="underlined">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="CadastroTela.cdtId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="preprocessData(CadastroTelas)" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-cdtVisivel="item">
                            <span>{{ item.cdtVisivel ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroTelasView',
    components: {
        EasyDataTable
    },
    data: () => ({
        CadastroTela: {
            cdtId: 0,
            cdtNome: '',
            cdtOrdem: '',
            cdtVisivel: '',
            cdtUrl: '',
            grtId:''
        },
        CadastroTelas: [],
        GrupoTelas:[],
        selectedVisivel: null,
        selectedGrupo: null,
        Status: [{ nome: "Sim", cdtVisivel: true }, { nome: "Não", cdtVisivel: false }],
        nameRules: [
            value => {
                if (value?.length <= 200) return true
                return 'Nome pode conter até 200 caracteres.'
            },
        ],

        headers: [
            { text: "Id", value: "cdtId", sortable: true, },
            { text: "Nome", value: "cdtNome", sortable: true, },
            { text: "Ordem", value: "cdtOrdem", sortable: true,},
            { text: "Visivel", value: "cdtVisivel", sortable: true, },
            { text: "Url", value: "cdtUrl" },
            { text: "Grupo Id", value: 'admGrupoTelas.grtId'},
            { text: "Grupo", value: 'admGrupoTelas.grtNome', sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                cdtOrdem: parseInt(item.cdtOrdem),
            };
            });
        },
        Limpar() {
            this.CadastroTela.cdtId = 0;
            this.CadastroTela.cdtNome = '';
            this.CadastroTela.cdtOrdem = '';
            this.CadastroTela.cdtVisivel = '';
            this.CadastroTela.cdtUrl = '';
            this.CadastroTela.grtId = '';
            this.selectedVisivel = '';
            this.selectedGrupo = null;
            this.Get();
        },
        Add() {
            if (this.CadastroTela.cdtNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.CadastroTela.cdtUrl == ''){
                this.$mensagemAviso("Url Obrigatória.")
            }
            else if (this.CadastroTela.cdtOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.CadastroTela.cdtVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.CadastroTela.grtId == '' || this.CadastroTela.grtId == null){
                this.$mensagemAviso("Grupo Obrigatório.")
            }
            else {
                this.CadastroTela.cdtOrdem = parseInt(this.CadastroTela.cdtOrdem)
                this.CadastroTela.admGrupoTelas = { grtId: this.CadastroTela.grtId};
                axios.post(`Process/AdmCadastroTelas/Add`, this.CadastroTela)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.CadastroTela.cdtNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.CadastroTela.cdtUrl == ''){
                this.$mensagemAviso("Url Obrigatória.")
            }
            else if (this.CadastroTela.cdtOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.CadastroTela.cdtVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.CadastroTela.grtId == '' || this.CadastroTela.grtId == null){
                this.$mensagemAviso("Grupo Obrigatório.")
            }
            else {
                this.CadastroTela.cdtOrdem = parseInt(this.CadastroTela.cdtOrdem)
                this.CadastroTela.admGrupoTelas = { grtId: this.CadastroTela.grtId};
                axios.put(`Process/AdmCadastroTelas/Update`, this.CadastroTela)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.CadastroTela = item;
            this.CadastroTela.grtId = item.admGrupoTelas.grtId
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.cdtId;
                axios.delete(`/Process/AdmCadastroTelas/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
            axios.get(`Process/AdmCadastroTelas/GetAll`)
                .then(response => {
                    this.CadastroTelas = response.data;
                });
        }
    },
    created() {
        this.Get();

        axios.get(`/Process/AdmGrupoTelas/GetAll`)
                .then(response => {
                    this.GrupoTelas = response.data.filter(x => x.grtVisivel).sort((a, b) => {
                                                                                            const nomeA = a.grtNome || ""; 
                                                                                            const nomeB = b.grtNome || ""; 
                                                                                            return nomeA.localeCompare(nomeB);
                                                                                            });
                });

    },
}
</script>

<style></style>
